<!-- KYMW1204 メモ編集 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">メモ編集</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <!-- メモ内容 -->
            <label class="list-input-title">メモ内容</label>
            <div class="list-input-content">
              <app-text-area id="tbx_catalogMemo" [tabindex]="0" forcedEnabledMode="true"
                [maxChars]="50" plessInputTextSub [restrict]="'[ -￮]'" [style.width.px]="420"
                [(ngModel)]="model.catalogMemo" [displayCountField]="false">
              </app-text-area>
            </div>
          </div>
          <!-- 企画回別商品一覧にもコピーする -->
          <div>
            <app-checkbox-label #chk_AllcoopValue [label]="'企画回別商品一覧にもコピーする'"
              [tabindex]="0" [(ngModel)]="model.copyCatalogMemoFlg" [disabled]="model.cycleFixedFlg">
            </app-checkbox-label>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <!-- button 設定 -->
          <button #btn_Set class="btn-primary" (click)="eventConfirm_CLICKHandler()" [tabindex]="0" forcedEnabledMode="true">確定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>